import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useForm, Controller, useFormContext} from 'react-hook-form';
import {makeGetRequest, makePostRequest} from '@ibibo/myaccount-reducer';
import {
  getRowFieldsDataSelector,
  aisCardsSelector,
  updateShowCardsMemo,
  showCardsSelector,
  updateAisCardsData,
  UPDATE_ROW_FIELDS_DATA,
} from '@ibibo/myaccount-reducer';
import classnames from 'classnames';
import * as S from './AisUpdateDetailsForm.styles';

import AisFormFields from './AisFormFields';
import CTA from '../../../common/CTA/CTA';
import classNames from 'classnames';

const AisUpdateDetailsForm = ({
  form,
  handleOpenModal,
  handleCloseModal,
  handleClick,
  setModalType,
  isModalForm,
}) => {
  const dispatch = useDispatch();
  const rowFieldsData = useSelector(getRowFieldsDataSelector);
  const showCardsMemoData = useSelector(showCardsSelector);
  const aisCards = useSelector(aisCardsSelector);

  const [flag, setFlag] = useState(false);

  const {
    handleSubmit,
    formState: defaultValues,
    reset,
    register,
    control,
    getValues,
    setValue,
  } = useForm();

  const onSubmit = data => {};

  /**Approve function to handle verification documents  api call*/
  const onFileApprove = (fileData, name) => {
    const values = getValues();
    setValue(name, fileData);
  };

  const onClickCB = action => {
    const formState = rowFieldsData;
    const {method, url, body} = action;
    isLoaded(false);
    setFlag(true);
    if (method == 'POST') {
      if (Object.keys(formState).length !== 0 && Object.keys(body).length !== 0) {
        for (const i in body) {
          body[i] = formState[i] || '';
        }
      }
      dispatch(makePostRequest(url, body, successCallback, errorCallback));
    }
  };

  const resetFormDataFromStore = body => {
    const state = rowFieldsData;
    for (const i in body) {
      body[i] = '';
    }
    dispatch({
      type: UPDATE_ROW_FIELDS_DATA,
      actionData: {...state, ...body},
    });
  };

  const successCallback = (resp, body) => {
    const {data, heading} = resp;

    isLoaded(true);
    setFlag(false);
    if (!data?.POPUP_TYPE) handleCloseModal();
    else {
      if (data?.POPUP_TYPE === 'DETAILS_VERIFIED') {
        setModalType(modalType => {
          return {formModal: false, verificationStatusModal: {showModal: true, ...data, heading}};
        });
        const obj = {...showCardsMemoData, ...data?.submitPopupModals};
        dispatch(updateShowCardsMemo(obj));

        if (data.collapsible_component_key) {
          const cardToUpdate = data.collapsible_component_key || '';
          const state = aisCards;
          state.data.rightSection[cardToUpdate] = data.component_data;
          dispatch(updateAisCardsData(state));
        }
      }
    }
    resetFormDataFromStore(body);
  };

  const errorCallback = (resp, body) => {
    const {data, message} = resp;
    isLoaded(true);
    setFlag(false);
    if (!data?.POPUP_TYPE) handleCloseModal();
    else {
      if (data?.POPUP_TYPE === 'DETAILS_VERIFIED') {
        setModalType(modalType => {
          return {formModal: false, verificationStatusModal: {showModal: true, ...data, message}};
        });
        const obj = {...showCardsMemoData, ...data?.submitPopupModals};
        dispatch(updateShowCardsMemo(obj));
      }
    }
    resetFormDataFromStore(body);
  };

  const handleOpenModalSubForm = () => {
    //setModalFlag(modalFlag => !modalFlag);
  };

  const handleCloseModalSubForm = () => {
    handleCloseModal?.();
  };

  const getDisableStatus = data => {
    const body = (data?.action?.api || {}).body;

    if (body && Object.keys(body)?.length) {
      for (const i in body) {
        if (!rowFieldsData[i]) {
          return false;
        }
      }
    }
    return true;
  };

  const isLoaded = (flag = true) => {
    return flag;
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {form?.length > 0 &&
        form.map((item, idx) => {
          /**
           * Render the each form in the below lines
           */
          const {order, rowFields, footer, primaryText, secondaryText} = item;
          return (
            <S.FormWrapper>
              {primaryText && <h4 className="primaryText">{primaryText}</h4>}
              {secondaryText && <h4 className="secondaryText">{secondaryText}</h4>}
              {order &&
                order?.length > 0 &&
                order.map(({fields}, rowIndex) => {
                  return (
                    <div
                      className={`formRow ${
                        !isModalForm && rowIndex !== order?.length - 1
                          ? 'pageRow aisListItem'
                          : 'pageLastRow'
                      }`}
                    >
                      {fields?.length > 0 &&
                        fields.map((rowElement, rowElementIndex) => {
                          return (
                            <>
                              <Controller
                                control={control}
                                name={rowFields[rowElement]?.name}
                                render={({field: {onChange, onBlur, value, ref}}) => (
                                  <AisFormFields
                                    value={value || rowFieldsData[rowFields[rowElement]?.name]}
                                    name={rowFields[rowElement]?.name}
                                    {...rowFields[rowElement]}
                                    register={register(
                                      `${rowFields[rowElement]?.name}`,
                                      rowFields[rowElement]?.register,
                                    )}
                                    onChange={e => {
                                      const state = rowFieldsData;
                                      const value = e.target.value;
                                      const nameOfField = rowFields[rowElement]['name'];
                                      dispatch({
                                        type: UPDATE_ROW_FIELDS_DATA,
                                        actionData: {...state, [nameOfField]: value},
                                      });
                                    }}
                                    onFileApprove={rowFields[rowElement]?.onApprove}
                                  />
                                )}
                              />
                            </>
                          );
                        })}
                    </div>
                  );
                })}
              <div className="footerCtaWrapper">
                {footer &&
                  footer?.ctas?.length &&
                  footer?.ctas.map(({component, data}, index) => {
                    return (
                      <CTA
                        onClickCB={onClickCB}
                        component={component}
                        data={data}
                        style={data?.styles}
                        closeModal={handleCloseModalSubForm}
                        isActive={getDisableStatus(data) && !flag}
                      />
                    );
                  })}
              </div>
            </S.FormWrapper>
          );
        })}
      {/* <button type="submit">Submit</button> */}
    </form>
  );
};

export default AisUpdateDetailsForm;
